import { useEffect } from "react";

import { useTenantId } from "./use-active-tenant-id";
import { User } from "../api/generated/backend";
import { toTenantIdHeader, useApiQuery } from "../api/use-api";
import { ME_KEY } from "../types/query-keys";
import { useCurrentNode } from "~/components/app-shell/providers/current-note-provider";

export const useUser = (): User | undefined => {
  const tenantId = useTenantId();
  const { data: user } = useApiQuery(
    "backend",
    (api) => api.getMe(toTenantIdHeader(tenantId)),
    ME_KEY(tenantId),
  );

  const { setNode } = useCurrentNode();
  useEffect(() => {
    if (user?.currentNode) {
      const { nodeId, type, subtype } = user.currentNode;
      setNode({
        node_id: nodeId,
        type: type as unknown as string,
        subtype: subtype as unknown as string,
      });
    }
  }, [user?.currentNode, setNode]);

  return user;
};
